// extracted by mini-css-extract-plugin
export default {"checkAll":"src-pages-Settings-Permissions-Components-SelectAll-css-module__checkAll--sDeM2"};